
















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import DataPushPO from "@/store/entities/devices/datapushpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
@Component({
    components: { TreeSelect },
})
export default class CreateDataPush extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    dataPushpo: DataPushPO = new DataPushPO();
    loading: boolean = false;
    async created() {
        this.dataPushpo.isEnable = 1;
        await this.areaTree();
        await this.getOrganizations();
    }
    save() {
        (this.$refs.itemForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                await this.$store.dispatch({
                    type: "datapush/create",
                    data: this.dataPushpo,
                }).catch((err) => {
                    this.$Modal.error({
                        title: this.L("ErrorInfo"),
                        content: err,
                    });
                    this.loading = false;
                });
                this.loading = false;
                (this.$refs.itemForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.itemForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
    }
    //获取组织
    async getOrganizations() {
        await this.$store
            .dispatch("organization/getselectTree")
            .then((val) => {
                this.$data.organizations = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    async areaTree() {
        await this.$store
            .dispatch("area/getAreaSelectTree")
            .then((val) => {
                this.$data.arealist = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    itemRule = {
        name: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        url: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            }
        ],
        organizationId: [
            {
                required: true,
                type: "number",
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        areaId: [
            {
                required: true,
                type: "number",
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
    };
    data() {
        return {
            arealist: [],
            organizations: [], //组织
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
        };
    }
}
